module.exports = __webpack_public_path__ + "static/media/triangle.e096fd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/triangle.png
// module id = 2310
// module chunks = 0